import { faBan, faCheck, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReportExecutionOut } from "kubb";
import type React from "react";
import { Badge } from "../../../components/Theme/badge";

interface Props {
  execution: ReportExecutionOut;
  wasCalculating: boolean;
  className?: string;
}

export default function ReportExecutionCalculatingBadge(
  props: Props,
): React.ReactElement {
  const { execution, wasCalculating, ...rest } = props;

  switch (execution.status) {
    case "CALCULATING":
      return (
        <Badge color={"brandLight"} {...rest}>
          <FontAwesomeIcon icon={faSpinner} spin={true} fixedWidth={true} />
          Calculating
        </Badge>
      );
    case "COMPLETED":
      if (wasCalculating) {
        return (
          <Badge color={"success"} {...rest}>
            <FontAwesomeIcon icon={faCheck} fixedWidth={true} />
            Ready
          </Badge>
        );
      } else {
        return <></>;
      }
    case "FAILED":
      return (
        <Badge color={"danger"} {...rest}>
          <FontAwesomeIcon icon={faBan} fixedWidth={true} className={"pr-1"} />
          Failed
        </Badge>
      );
    default:
      return <></>;
  }
}
